import { request } from "utils/api";
import { serialize } from "object-to-formdata";

// comment schema
export interface Comment {}

// create comment under story or booking (POST /reactions/comments)
export const postComment = (data: {
    attachedMedia?: File,
    bookingId?: string,
    commentId?: string,
    content: string,
    storyId?: string,
}) => request<Comment>({
    data: serialize(data),
    endpoint: "/reactions/comments",
    method: "post",
});
